document.addEventListener('DOMContentLoaded', () => {
	const items = document.querySelectorAll(
		'.footer__block-list .footer__block--links'
	);

	const closeItem = (item) => {
		const content = item.querySelector('.unstyled-list');

		item.classList.remove('is-active');

		// If height is auto, convert it to pixels before animating
		content.style.height = `${content.scrollHeight}px`;

		requestAnimationFrame(() => {
			content.style.height = '0px';
			content.style.opacity = '0';
		});
	};

	const openItem = (item) => {
		const content = item.querySelector('.unstyled-list');

		item.classList.add('is-active');

		content.style.height = `${content.scrollHeight}px`;
		content.style.opacity = '1';

		content.addEventListener(
			'transitionend',
			() => {
				if (item.classList.contains('is-active')) {
					content.style.height = 'auto';
				}
			},
			{ once: true }
		);
	};

	const resetAccordion = () => {
		items.forEach((item) => {
			const content = item.querySelector('.unstyled-list');

			item.classList.remove('is-active');

			if (window.innerWidth <= 600) {
				content.style.height = '0px';
				content.style.opacity = '0';
			} else {
				content.style.height = '';
				content.style.opacity = '';
			}
		});
	};

	items.forEach((item) => {
		const header = item.querySelector('.h6');

		header.addEventListener('click', () => {
			// Do nothing above 600px
			if (window.innerWidth > 600) return;

			const isOpen = item.classList.contains('is-active');

			// Close every other item
			items.forEach((otherItem) => {
				if (otherItem !== item) {
					closeItem(otherItem);
				}
			});

			// Toggle clicked item
			isOpen ? closeItem(item) : openItem(item);
		});
	});

	// Initial state
	resetAccordion();

	// Reset when crossing screen sizes
	let isMobile = window.innerWidth <= 600;

	window.addEventListener('resize', () => {
		const newIsMobile = window.innerWidth <= 600;

		if (newIsMobile !== isMobile) {
			isMobile = newIsMobile;
			resetAccordion();
		}
	});
});